module.exports = __webpack_public_path__ + "media/scholarship_winners/karlee-sw-cb13d4b4.png";